
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsList.vue";
  import DocumentItem from "@/components/documents/DocumentItem.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
  import DocumentUserInformation from "@/components/documents/DocumentUserInformation.vue";

  import { Company, User, Document } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      DocumentItem,
      CardBodyItem,
      ManagersMultiselect,
      DocumentUserInformation,
    },
  })
  export default class DocumentsAdminManagers extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    selectedManagersIds: string[] = [];
    filtersTouched: boolean = false;

    get query(): Object {
      return {
        _and: [
          { company_id: { _eq: this.company.id } },
          { filename: { _ilike: `%${this.$route.query.search || ""}%` } },
          this.getManagersFilterConditions(),
          { uploaded_by: { _eq: this.currentUser.id } },
          { attached_to: { user: { role: { _eq: "MANAGER" } } } },
        ],
      };
    }

    onManagerSelected(selectedManagersIds: string[]): void {
      this.selectedManagersIds = selectedManagersIds;
      this.filtersTouched = true;
    }

    isDocumentAttachedToSomeone(document: Document): boolean {
      return document.attached_to.length > 0;
    }

    getManagersFilterConditions(): Object {
      if (this.selectedManagersIds.length === 0) {
        return {};
      }

      const conditions = this.selectedManagersIds.map(managerId => ({
        attached_to: {
          user: {
            manager: {
              id: {
                _eq: managerId,
              },
            },
          },
        },
      }));

      return { _or: conditions };
    }
  }
